<template>
  <a-modal
    class="custom-modal"
    unmount-on-close
    :esc-to-close="false"
    :mask-closable="false"
    v-bind="$attrs">
    <template v-for="(value, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}"></slot>
    </template>
  </a-modal>
</template>
